import React from 'react'
// import './TodosError.css';

function TodosError() {

  return (
    <p>Error...</p>
  )
}

export {TodosError};